import { service } from '@ember/service'
import Route from '@ember/routing/route'
import type Transition from '@ember/routing/transition'
import IntlService from 'ember-intl/services/intl'
import translationsForEnUs from 'virtual:ember-intl/translations/en-us'
import SentryService from 'customer-flows/services/sentry'

export default class ApplicationRoute extends Route {
  @service frameManager: FrameManager
  @service session: Session
  @service flowRouter: FlowRouter
  @service intl: IntlService
  @service sentry: SentryService

  async beforeModel(transition: Transition): Promise<boolean> {
    this.intl.addTranslations('en-us', translationsForEnUs)
    this.intl.setLocale(['en-us'])

    this.session.setup()
    this.flowRouter.setup(transition)
    this.frameManager.setup()
    this.sentry.setup()

    return true
  }
}
